import { useQuery } from '@tanstack/react-query';
import { getStudyAreas } from '@api/studyAreas';

export const useStudyAreas = () => {
  return useQuery({
    queryKey: ['studyAreas'],
    queryFn: getStudyAreas,
  });
};
